import React from "react";
import {Box} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import {Header} from "../../HeaderComponent/Header";
import {Footer} from "../../FooterComponent/Footer";

export default function PageContainer({ children }: { children: React.ReactNode }) {

    const theme = useTheme();

    return (
        <Box sx={{width:'100vw', height:'100vh', display: 'flex', flexDirection:'column', backgroundColor: theme.palette.blue}}>
            <Box height={'10vh'}><Header/></Box>
            <Box sx={{height: '80vh', paddingLeft: theme.spacing.xl, paddingRight: theme.spacing.xl}}>{children}</Box>
            <Box height={'10vh'}><Footer/></Box>
        </Box>
    );
}